import { IS_DEV } from '~app/core/env';

export const storage = {
  encode: !IS_DEV,
  _generateKey(key: string) {
    const prefixedKey = `$SysdyneID$${key}`;
    return this.encode ? btoa(encodeURIComponent(prefixedKey)) : prefixedKey;
  },
  _toStorageString(payload: any): string {
    const payloadString = JSON.stringify(payload);
    return this.encode ? btoa(encodeURIComponent(payloadString)) : payloadString;
  },
  _fromStorageString(value: string): any {
    return JSON.parse(this.encode ? decodeURIComponent(atob(value)) : value);
  },
  save<T>(key: string, payload: T) {
    localStorage.setItem(this._generateKey(key), this._toStorageString(payload));
    return payload;
  },
  load(key: string) {
    const value = localStorage.getItem(this._generateKey(key));
    return value && this._fromStorageString(value);
  },
  remove(key: string) {
    localStorage.removeItem(this._generateKey(key));
  },
};
